import { Injectable } from '@angular/core'

@Injectable({ providedIn: 'root' })
export class BeforeUnloadService {
  private listener: EventListener | undefined

  preventUnload (message: string): void {
    if (this.listener) {
      return
    }
    this.listener = e => {
      e.preventDefault()
      e.returnValue = message as any
      return message
    }
    window.addEventListener('beforeunload', this.listener)
  }

  allowUnload (): void {
    if (!this.listener) {
      return
    }
    window.removeEventListener('beforeunload', this.listener)
    this.listener = undefined
  }
}
